import { arrayMove } from "@dnd-kit/sortable";

/**
 * Reorders the column preferences after a drag.
 *
 * Only reorderable columns take part. Filter-only columns are never drawn in the table, so they
 * have no position a user could drag to — they lead the list and stay there, and the move happens
 * among the rest. Positions are re-indexed across the whole list afterwards so they stay
 * contiguous and keep agreeing with the order the filter picker is built from.
 *
 * Returns the list unchanged when either id is not something that can be moved.
 */
export const moveColumn = (items, activeId, overId) => {
  const fixed = items.filter((item) => item.filterOnly);
  const movable = items.filter((item) => !item.filterOnly);

  const oldIndex = movable.findIndex((item) => item.id === activeId);
  const newIndex = movable.findIndex((item) => item.id === overId);
  if (oldIndex === -1 || newIndex === -1) return items;

  return [...fixed, ...arrayMove(movable, oldIndex, newIndex)].map(
    (item, index) => ({ ...item, position: index }),
  );
};
